import React from "react";
import "../../styles/components/Fields/InputField.scss";

const InputField = ({className, value, type, onChange, index}) =>
  <input
    key={`${index}-${className}`}
    className={`input-box ${className}`}
    type={type}
    value={value}
    onChange={e => onChange(e.target.value, index)}
  />;

export default InputField;
